<template>
	<div class="step-wrapper">
		<!-- Context Image 1 -->
		<div class="link-container">
			<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message1')"/>
			<div class="link-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message2')" @click="emit('helperStepUpdate', 4)"/>
		</div>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message3')"/>
		<div class="context-image step-5-1"/>
		<!-- Context Image 2 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message4')"/>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message5')"/>
		<div class="context-image step-5-2"/>
		<!-- Context Image 3 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message6')"/>
		<div class="context-image step-5-3"/>
		<!-- Context Image 4 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message7')"/>
		<div class="context-image step-5-4"/>
		<div v-for="(topic, index) in stepTopics1" :key="`topic-${index}`" class="topics">
			<span class="circle"/>
			<span v-html="topic"/>
		</div>
		<!-- Context Image 5 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message8')"/>
		<div class="context-image step-5-5"/>
		<div v-for="(topic, index) in stepTopics2" :key="`topic-${index}`" class="topics">
			<span class="circle"/>
			<span v-html="topic"/>
		</div>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message9')"/>
		<!-- Context Image 6 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message10')"/>
		<div class="context-image step-5-6"/>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message11')"/>
		<!-- Context Image 7 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message12')"/>
		<div class="context-image step-5-7"/>
		<!-- Context Image 8 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message13')"/>
		<div class="context-image step-5-8"/>
		<!-- Context Image 9 -->
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message14')"/>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message15')"/>
		<div class="step-message" v-html="t('payments.batchfile.newPayment.helperModal.step5.message16')"/>
		<div class="context-image step-5-9"/>
	</div>
</template>

<script setup>
/* Vue */
import { ref } from 'vue'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* Emmitters */
const emit = defineEmits(['helperStepUpdate'])

/* Topics */
const stepTopics1 = ref([
	t('payments.batchfile.newPayment.helperModal.step5.topics1.topic1'),
	t('payments.batchfile.newPayment.helperModal.step5.topics1.topic2'),
	t('payments.batchfile.newPayment.helperModal.step5.topics1.topic3'),
	t('payments.batchfile.newPayment.helperModal.step5.topics1.topic4'),
    t('payments.batchfile.newPayment.helperModal.step5.topics1.topic5')
])

const stepTopics2 = ref([
	t('payments.batchfile.newPayment.helperModal.step5.topics2.topic1'),
	t('payments.batchfile.newPayment.helperModal.step5.topics2.topic2'),
	t('payments.batchfile.newPayment.helperModal.step5.topics2.topic3'),
	t('payments.batchfile.newPayment.helperModal.step5.topics2.topic4'),
	t('payments.batchfile.newPayment.helperModal.step5.topics2.topic5')
])
</script>

<style lang="scss" scoped>
.step-wrapper {
	width: 100%;
	padding-bottom: 56px;

	display: flex;
	flex-direction: column;
    color: var(--secondary-dark-2);

	gap: 24px;

	.link-container {
		display: flex;
		flex-direction: column;
		.step-message {
			@include H7-Regular;
			line-height: 16px;
			word-wrap: break-word;
		}

		.link-message {
			@include H7-Medium;
			line-height: 16px;
			word-wrap: break-word;
			text-decoration: underline;

			cursor: pointer;
		}
	}
	.step-message {
		@include H7-Regular;
        line-height: 16px;
		word-wrap: break-word;
	}

	.topics {
			width: 100%;

			display: flex;
			align-items: center;
			justify-content: flex-start;

			@include H7-Regular;
			line-height: 16px;

			.circle {
				width: 4px;
				height: 4px;
				margin-right: 8px;

				flex-shrink: 0;

				border-radius: 50%;
				background-color: var(--secondary-dark-2);
			}
		}

	.context-image {
		width: 100%;
		height: 250px;
		max-width: 512px;

		background-position: 50%;
		background-size: contain;
		background-repeat: no-repeat;

		&.step-5-1 {
			width: 100%;
			height: 322px;
			background-image: url('~@/assets/images/batchfileHelper/image-11.jpg');
		}

		&.step-5-2 {
			width: 100%;
			height: 322px;
			background-image: url('~@/assets/images/batchfileHelper/image-12.jpg');
		}

		&.step-5-3 {
			width: 100%;
			height: 162px;
			background-image: url('~@/assets/images/batchfileHelper/image-2.jpg');
		}

		&.step-5-4 {
			width: 100%;
			height: 492px;
			background-image: url('~@/assets/images/batchfileHelper/image-3.jpg');
		}

		&.step-5-5 {
			width: 100%;
			height: 237px;
			background-image: url('~@/assets/images/batchfileHelper/image-4.jpg');
		}

		&.step-5-6 {
			width: 100%;
			height: 153px;
			background-image: url('~@/assets/images/batchfileHelper/image-5.jpg');
		}

		&.step-5-7 {
			width: 100%;
			height: 430px;
			background-image: url('~@/assets/images/batchfileHelper/image-6.jpg');
		}

		&.step-5-8 {
			width: 100%;
			height: 110px;
			background-image: url('~@/assets/images/batchfileHelper/image-7.jpg');
		}

		&.step-5-9 {
			width: 100%;
			height: 110px;
			background-image: url('~@/assets/images/batchfileHelper/image-8.jpg');
		}
	}
}
</style>
